module.exports = __webpack_public_path__ + "img/feature_buy_th.0c7b6844.png";